import {
  AutocompleteInput,
  BooleanInput,
  DeleteButton,
  Edit,
  email,
  FormDataConsumer,
  minLength,
  RadioButtonGroupInput,
  ReferenceInput,
  required,
  SimpleForm,
  SaveButton,
  TextInput,
  Toolbar,
  useGetOne,
  useTranslate
} from 'react-admin'

import { SxProps } from '@mui/material'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'
import { filterToQuery } from '../../utils'
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts'
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton'

const PlacesUsersEditToolbar = () => (
  <Toolbar sx={{ gap: 1 }}>
    <SaveButton />
    <ResendEmailButton size="medium" />
    <Permission permission={PERMISSIONS.ADMIN}>
      <MarkVerifiedButton size="medium" />
    </Permission>
    <Permission permission={PERMISSIONS.UPDATE_LOCAL_USER}>
      <DeleteButton mutationMode="pessimistic" redirect="/_employees" confirmTitle="Excluir usuário" sx={{ marginLeft: 'auto' }} />
    </Permission>
  </Toolbar>
);

const profilesSx: SxProps = {
  width: 220,
};

const validatePassword = [minLength(6)]
const validateEmail = [required(), email()]

const PlaceProfilesInput = ({ placeId }: { placeId?: string }) => {
  const { data: place } = useGetOne(
    'places',
    { id: placeId },
    { enabled: !!placeId },
  );
  return (
    <ReferenceInput
      sx={profilesSx}
      source="profileId"
      reference="profiles"
      sort={{ field: 'name', order: 'ASC' }}
      perPage={9999}
      filter={place?.chainId ? { chainId: place.chainId } : undefined}>
      <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
    </ReferenceInput>
  );
};

export default props => {
  const translate = useTranslate();

  return (
    <Permission permission={PERMISSIONS.UPDATE_LOCAL_USER}>
      <Edit {...props} title="Editar usuário">
        <SimpleForm sx={{ maxWidth: 600 }} toolbar={<PlacesUsersEditToolbar />}>
          <EmailVerificationWarning />
          <ReferenceInput
            reference="places"
            source="placeId"
            sort={{ field: "name", order: "ASC" }}
            perPage={null}
          >
            <AutocompleteInput
              filterToQuery={filterToQuery}
              label="Parceiro ou Posto"
              optionText="name"
              isRequired
              validate={required()}
              sx={{ minWidth: 220 }}
              noOptionsText={translate('ra.input.autocomplete.no_options_text')}
            />
          </ReferenceInput>
          <TextInput source="name" label="Nome" validate={[required()]} sx={{ minWidth: 220 }} InputProps={{ autoComplete: 'off' }} />
          <TextInput source="login" label="Login" validate={validateEmail} sx={{ minWidth: 220 }} InputProps={{ autoComplete: 'off' }} />
          <TextInput
            source="password"
            label="Senha"
            validate={validatePassword}
            sx={{ minWidth: 220 }}
            InputProps={{ autoComplete: 'new-password' }}
          />
          <FormDataConsumer>
            {({ formData }) => <PlaceProfilesInput placeId={formData.placeId} />}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
        </SimpleForm>
      </Edit>
    </Permission>
  )
}
